import React from 'react';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Image1 from "../../Assets/images/dance.jpg"
import Image2 from "../../Assets/images/user1.png"
import Image3 from "../../Assets/images/user2.png"
import Image4 from "../../Assets/images/user3.png"
import Image5 from "../../Assets/images/dashboard4.png"
import { useNavigate } from 'react-router-dom';
import GameHeader from '../header/header';
const Dashboard = () => {

    let navigate = useNavigate();

    const handleAdminlogin = () => {
        navigate(`/login`);
    };

    const handleSignUplogin = () => {
        navigate(`/SignUp`);
    };
    const handleterms = () => {
        navigate(`/terms`);
    };
    return (
        <div className="obtibg">
            <div className="containerbasd">
                <GameHeader />
                <div className="terms-container">
                    <div className="terms-content">
                        <img className='mb-3 imgbsaox' src={Image5} />
                        <h1>About epic games</h1>
                        <h2>Welcome to Epic Games</h2>
                        <p>
                            Where creative imagination meets technical innovation. We have been honing our craft since 2010 as a creative technology company dedicated to making captivating virtual worlds and spatial experiences that redefine the boundaries of interactive products.
                        </p>

                        <p>
                            At epic games, we believe in the power of immersive storytelling and cutting-edge technology to transport users to extraordinary realms. Our team of visionary designers, developers, and artists collaborate to create virtual environments that blur the line between reality and magical, offering unparalleled adventures that ignite the senses and inspire the mind.
                        </p>

                        <p>
                            As pioneers in the field of immersive interactive experiences, we constantly push the boundaries of what's possible. Our collaboration with storytellers have created virtual worlds that are not just mere escapes; they are dynamic, ever-evolving platforms that encourage exploration, discovery, and social interaction. Whether you're embarking on an epic quest, collaborating with friends, or simply indulging in a moment of tranquility, epic games's virtual worlds offer limitless possibilities.
                        </p>

                        <p>
                            With a creative passion for technical innovation and a commitment to delivering unrivaled experiences, epic games is at the forefront of the spatial computing revolution. Step into our worlds and let your imagination soar. Welcome to the future of interactive spatial experiences.
                        </p>
                        <h1 className='mt-5'>CREATIVE & TECHNICAL AREAS OF FOCUS</h1>
                        <div className='d-flex gap-5'>
                            <div className='w-50 center'>
                                <p>
                                    Real-Time 3D <br />
                                    Spatial <br />
                                    Avatars <br />
                                    Immersive Video
                                </p>
                            </div>
                            <div className='w-50 center'>
                                <p>
                                    Interactive <br />
                                    Generative AI <br />
                                    Simulations <br />
                                    Mirror Worlds
                                </p>
                            </div>
                        </div>
                        <h1 className='mt-5'>CREATORS WHO HAVE BEEN THERE</h1>

                        <div className='center '>
                            <img src={Image1} className='imgbsaox' />
                        </div>
                        <h1 className='mt-5'>Epic Team</h1>
                        <p>
                            The epic games team includes developers, artists, and producers who've been at the forefront of virtual world-building since the beginning. From Academy Awards winners to serial entrepreneurs, we're all creators at heart.
                        </p>
                        <div className='center'>
                            <img src={Image2} className='scondimg' />
                        </div>
                        <div className='center'>
                            <img src={Image3} className='scondimg' />
                        </div>
                        <div className='center'>
                            <img src={Image4} className='scondimg' />
                        </div>
                        <h1 className='mt-lg-5'>LET'S WORK TOGETHER</h1>
                        <p>
                            © 2025 Epic Games.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;